import React, {Component} from "react"
import PropTypes from "prop-types"
import {observer} from "mobx-react"
import {Table} from "semantic-ui-react"
import _ from "lodash"
import ProductRowDefault from "components/Product/ProductRowDefault"

@observer
export default class ProductTable extends Component {
	static propTypes = {
		list    : PropTypes.object,
		cart    : PropTypes.object,
		onChange: PropTypes.func,
		products: PropTypes.array,
	}

	render() {
		let {list, cart, products, onChange} = this.props
		let ProductRow = this.props.row || ProductRowDefault
		let positions = list || products
		if ( list ) positions = list.products
		let rows = _.map( positions, ( product, index ) => {
			return (
				<ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product} />
			)
		} )
		return (
			<Table>
				<colgroup>
					<col width="30" />
					<col width="" />
					<col width="20%" />
					<col width="10%" />
					<col width="10%" />
					<col width="10%" />
					<col width="10%" />
					<col width="10%" />
					<col width="10%" />
				</colgroup>
				<thead>
				<tr>
					<th>&nbsp;</th>
					<th>{translate( "article" )}</th>
					<th>&nbsp;</th>
					<th>{translate( "deliverable" )}</th>
					<th>{translate("Preis/Stück")}</th>
					<th>{translate("Preis/VE")}</th>
					<th>{translate( "total count" )}</th>
					<th>{translate( "sum" )}</th>
					<th>{translate( "VE" )}</th>
					<th style={{textAlign: "right"}}>{translate( "amount (VE)" )}</th>
					{list && <th style={{textAlign: "right"}}>{translate( "" )}</th>}
				</tr>
				</thead>
				<tbody>
				{rows}
				</tbody>
			</Table>
		)
	}
}







// WEBPACK FOOTER //
// ./src/components/Product/ProductTable.js